<template>
  <div class="project-page" ref="storyView">
    <div class="all-content neweng-print-bg">
      <loader :loading="projectLoading" />
      <story-header v-if="loaded && projectPostsLoaded" ref="storyHeader" :fromTemplate="fromTemplate" :fromPostCreate="fromPostCreate" :hasQuickRead="hasQuickRead"></story-header>
      <div v-if="hasQuickRead" class="quickread">
        <div class="quickread-title title is-6 has-text-primary is-marginless">{{$t('projectPage.quickRead')}}</div>
        <div class="quickread-body">
          <ul>
            <li v-for="(bullet, idx) in project.quickRead" v-bind:key="idx">
              <span>{{ bullet }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="hasQuickRead" class="deepdive">
        <div class="deepdive-title title is-6 has-text-primary is-marginless">{{$t('projectPage.deepDive')}}</div>
      </div>
      <div v-if="!hasQuickRead" class="fake-padding print-bg"></div>
      <component :is="activeTab" class="component print-bg"></component>
      <board v-if="loaded"></board>
      <story-footer v-if="loaded" :project="project"></story-footer>
    </div>
    <confirm ref="unsavedModal" :title="$t('projectPage.confirmCancel')" text="It looks like something isn’t saved on your Board. Are you sure you want to discard your changes?"  @yes="unsavedModalYes" @no="unsavedModalNo"></confirm>
    <modal-report></modal-report>
  </div>
</template>

<script>
import StoryHeader from './Header/StoryHeader'

import List from './Tabs/List'
import NotFound from './Tabs/NotFound'

import StoryFooter from './StoryFooter'

import Board from '@/components/MagicBoard/Modal'
import Confirm from '@/components/Modals/Confirm'
import ModalReport from '@/components/UIReport/Modal'
import ResourceCta from '@/components/Forms/ResourceCta'
import Loader from '@/components/Base/Loader/loader'
import resources from '@/mixins/resources'

import mixin from './index'

export default {
  name: 'viewStory',

  data: function () {
    return {
      timer: null,
      dispatchedCount: 0
    }
  },
  components: {
    Loader,
    StoryHeader,
    StoryFooter,
    List,
    NotFound,
    Board,
    Confirm,
    ModalReport,
    ResourceCta
  },
  mixins: [mixin, resources],
  mounted: function () {
    setTimeout(() => {
      this.openFlag = true
    }, 8 * 1000)
  },
  watch: {
    project: function (newProject) {
      // (RV Warning: you know the code is bad when it's needs a long comment like this :))
      // We need this code below because not all API calls that get a project return the
      // primary category id so if the project is in the cache without the primary category
      // we need to attempt to get it.  BUT we should only try doing this thrice since
      // some articles do not have a primary category id.
      if (newProject && newProject.primaryCategoryID === 0 && this.dispatchedCount < 3) {
        this.dispatchedCount++
        const params = {
          id: newProject.id,
          force: true
        }
        this.$store.dispatch('getProject', params)
      }
    }
  },
  destroyed () {
    clearTimeout(this.timer)
  },
  computed: {
    hasQuickRead: function () {
      return this.project.quickRead && this.project.quickRead.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.component {
  box-shadow: none;
}

.project-page {
  background-color: #F8F8F8;
  min-height: calc(100vh - 52px);
  padding-bottom: 3rem;
  @include fix-ios-scrolling;

  @include mobile {
    padding-bottom: 2rem;
    overflow-x: hidden;
  }
}
.all-content {
  background-color: #F8F8F8;
}

.loader-container {
  padding: 1rem;
  .loader {
    display: block;
    font-size: 2rem;
    margin: auto;
  }
}
.quickread-title, .deepdive-title {
  padding: 2rem 3rem 1rem;
  border-top: 0.5rem solid var(--background-fifth);
  border-bottom: 1px solid var(--background-fifth);
  @include mobile {
    padding: 1rem;
  }
}
.quickread-body {
  font-family: 'Noto Serif JP', serif;
  padding: 1rem 3rem 2rem;
  @include mobile {
    padding: 1rem 1rem 2rem;
  }
  ul li {
    padding: 0 2rem;
    margin: 5px;
    list-style: disc inside;
    @include mobile {
      padding: 0 1rem;
    }
  }
}
.fake-padding { // Padding removed with new QuickRead section
  height: 2rem;
}

.cta-button {
//   margin: auto;
  @include mobile {
    margin-left: 0;
  }
}
  .cta-container {
    margin: auto 0;
    width: 100%;
}
</style>
